import { useEffect, useState, useCallback } from "react";
import { CommonPropertyProps, PopulatesData } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import { useTranslation } from "react-i18next";
import { SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps;
	populatesData?: PopulatesData[];
	canPopulate?: boolean;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	populatesData,
	validation,
	elementIndex,
	canPopulate,
}: Props) => {
	const { t } = useTranslation();
	const [populatesFields, setPopulatesFields] = useState<
		SearchSelectOptionProps[]
	>([]);

	const [init, setInit] = useState(false);

	const getElements = useCallback(() => {
		// Gets list of elements from the element names in the legacyArrayView
		if (populatesData) {
			const tempPopulates: SearchSelectOptionProps[] = [];
			let found = false;

			// Create new element list and mark if current value is in there
			populatesData.forEach(populates => {
				if (populates.from !== undefined) {
					if (
						value !== undefined &&
						value !== null &&
						value.value === populates.from
					)
						found = true;

					tempPopulates.push({
						value: populates.from,
						label: populates.from,
					});
				}
			});
			// If current value is not in the list then list has changed, so delete value
			if (!found && value) {
				updateStore({
					elementIndex,
					property: field,
					value: null,
				});
			}
			setPopulatesFields(tempPopulates);
		}
	}, [elementIndex, field, populatesData, updateStore, value]);

	useEffect(() => {
		getElements();
	}, [getElements, populatesData]);

	useEffect(() => {
		if (init) {
			if (!canPopulate && value !== undefined && value !== null)
				updateStore({
					elementIndex,
					property: field,
					value: null,
				});
		} else setInit(true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [canPopulate]);

	const props = {
		updateStore,
		field,
		required,
		value,
		validation,
		desc,
		elementIndex,
		options: populatesFields,
		disabled: populatesFields.length && populatesData ? false : true,
		disabledPlaceholder: t(
			"formDesigner.placeholders.populatesFromRelation"
		),
	};

	if (canPopulate) return <SearchSelectContainer {...props} />;
	else return <></>;
};
